import React from "react";

function index() {
  return (
    <div className="text">
      <p style={{ textAlign: "justify" }}>
        DEM Nasional dibangun dari beberapa sumber data meliputi data IFSAR
        (resolusi 5m), TERRASAR-X (resolusi <i>resampling</i> 5m dari resolusi
        asli 5-10 m) dan ALOS PALSAR (resolusi 11.25 m), dengan menambahkan data{" "}
        <i>mass point</i> yang digunakan dalam pembuatan peta Rupabumi Indonesia
        (RBI). Resolusi spasial DEMNAS adalah 0.27-arcsecond, dengan menggunakan
        datum vertikal EGM2008.
      </p>
      <figure>
        <img
          className="figure-img"
          src={process.env.PUBLIC_URL + "/static/img/sample_DEMNAS04.png"}
          style={{ width: "400px" }}
        />
        <figcaption>DEMNAS</figcaption>
      </figure>
      {/*
      <h2>Batimetri Nasinonal</h2>
      <p style={{ textAlign: "justify" }}>
        Batimetri Nasional dibentuk dari hasil inversi data{" "}
        <em>gravity anomaly</em> hasil pengolahan data almetri dengan
        menambahkan data pemeruman (<em>sounding</em>) yang dilakukan oleh BIG,
        NGDC, BODC, BPPT, LIPI, P3GL dan lembaga lainnya dengan survei{" "}
        <em>single</em> maupun <em>multibeam</em>. Resolusi spasial data BATNAS
        adalah 6arc-second dengan menggunakan datum MSL.
      </p>
      <figure>
        <img
          className="figure-img"
          src="assets/img/BATNAS.png"
          style={{ width: "600px" }}
        />
        <figcaption>
          <em>Gridded</em> BATimetri NASional
        </figcaption>
      </figure>
      <p style={{ textAlign: "justify" }}>
        Data <em>gridded</em> BATimetri NASional dari 90 sampai 150BT dan dari
        20LS sampai 20LU. Data batimetri ini mempunyai keunggulan di daerah
        pesisir dan perairan dangkal dengan menggunakan survei dari Pusat
        Kelautan dan Lingkungan Pantai (PKLP), BIG.
      </p>
      */}
    </div>
  );
}

export default index;
